<template>
    <div>
        <v-toolbar :height="height" :flat="flat" :class="className">
            <slot name="left-controls"></slot>
            <template v-if="enableIcon">
                <v-icon v-if="$route.meta.icon" small class="mr-1">{{ $route.meta.icon }}</v-icon>
            </template>
            <v-toolbar-title class="subtitle-1">{{ title }}</v-toolbar-title>
            <v-spacer v-if="rightSideControl"></v-spacer>

            <slot name="right-controls"></slot>
        </v-toolbar>
        <v-divider></v-divider>
    </div>
</template>

<script>
export default {
    props: {
        enableIcon: {
            type: Boolean,
            default: true
        },
        height: {
            type: Number,
            default: 55
        },
        flat: {
            type: Boolean,
            default: true
        },
        className: {
            type: String,
            default: 'cardHeaderTheme'
        },
        title: {
            type: String,
            required: true
        },
        rightSideControl: {
            type: Boolean,
            default: true
        }
    }
}
</script>